
// Dropdown and mega menu

const ddButtons = document.getElementsByClassName("mob-parent-button");

// Loop through each button
for (const ddButton of ddButtons) {
  // Add a click event listener to the button
  ddButton.addEventListener("click", function (event) {
    // Prevent the default behavior of the button click
    event.preventDefault();
    // Find the next sibling element and add the "active" class to it
    const nextElement = ddButton.nextElementSibling;
    if (nextElement) {
      nextElement.classList.add("active");
      updateSlHideVisibility();
    }
  });
} 

const ddPanels = document.querySelectorAll(".mob-secondary-level-ul, .mob-third-level-ul");

// Function to update the visibility of sl-hide divs
function updateSlHideVisibility() {
  const isActivePanel = Array.from(ddPanels).some(panel => panel.classList.contains("active"));
  const slHideDivs = document.getElementsByClassName("sl-hide");

  for (const slHideDiv of slHideDivs) {
    if (isActivePanel) {
      slHideDiv.classList.add("sl-hide-oi");
    } else {
      slHideDiv.classList.remove("sl-hide-oi");
    }
  }
}

// Loop through each panel
for (const ddPanel of ddPanels) {
  // Find the "nav-secondary-fo-back-button" within the current panel
  const backButton = ddPanel.querySelector(".nav-secondary-fo-back-button");

  // Add a click event listener to the back button
  backButton.addEventListener("click", function () {
    // Remove the "active" class from the parent panel
    ddPanel.classList.toggle("active");
    updateSlHideVisibility();
  });

  // MutationObserver for each panel
  const panelObserver = new MutationObserver(() => {
    updateSlHideVisibility();
  });

  const observerConfig = { subtree: true, childList: true, attributes: true, characterData: true };
  panelObserver.observe(ddPanel, observerConfig);
}


// Accordion menu system

document.addEventListener("DOMContentLoaded", function () {
  var drawerAccordionButtons = document.querySelectorAll(".mob-parent-accordion-button");
  drawerAccordionButtons.forEach(function (drawerAccordionButton) {
    drawerAccordionButton.addEventListener("click", function () {
      var panel = drawerAccordionButton.nextElementSibling;

      // Toggle the "open" class for the accordion heading
      if (drawerAccordionButton.classList.contains("active")) {
        drawerAccordionButton.classList.remove("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'false');
        panel.style.height = null;
        setTimeout(function () {
          panel.classList.remove("panel-open");
          panel.setAttribute('aria-hidden', 'true');
        }, 600);
      } else {
        drawerAccordionButton.classList.add("active");
        drawerAccordionButton.setAttribute('aria-expanded', 'true');
        panel.style.height = panel.scrollHeight + "px";
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add("panel-open");
      }
    });
  });
});


// Dropdown menu interaction
if (!document.querySelector('.nav-desktop-dd-btn-clickable')) {
  const navDesktopButtons = document.querySelectorAll('.nav-desktop-dd-btn');
  const headerMegaFwLists = document.querySelectorAll('.header-nav-desktop-dd-panel');
  const gcHeader = document.querySelector('.header-bar-inner');
    
  function applyBackgroundColor() {
    gcHeader.classList.add('hovered');
  }
  
  function removeBackgroundColor() {
    gcHeader.classList.remove('hovered');
  }
  
  navDesktopButtons.forEach((navDesktopButton) => {
    navDesktopButton.addEventListener('mouseover', applyBackgroundColor);
    navDesktopButton.addEventListener('mouseout', removeBackgroundColor);
  });
  
  headerMegaFwLists.forEach((headerMegaFwList) => {
    headerMegaFwList.addEventListener('mouseover', applyBackgroundColor);
    headerMegaFwList.addEventListener('mouseout', removeBackgroundColor);
  });
}

// Scrolling transition for transparent header option

const headerDiv = document.getElementById('SiteHeader');
const hadHdrTransHpInitially = headerDiv.classList.contains('hdr-trans-hp');
const hasScrollBehaviour = headerDiv.querySelector('.hb-scroll-behaviour--scroll');

let isScrolled = false;
if (!hasScrollBehaviour) {
window.addEventListener('scroll', function() {
  const scrollPosition = window.pageYOffset;

  if (scrollPosition > 300 && !isScrolled) {
    headerDiv.classList.remove('hdr-trans-hp');
    isScrolled = true;
  } else if (scrollPosition <= 300 && isScrolled) {
    if (hadHdrTransHpInitially) {
      headerDiv.classList.add('hdr-trans-hp');
    }
    isScrolled = false;
  }
});
}

// Menu drawer opening and closing

// var navdrawermobile = document.getElementById('mobNavDrawer');
// var drawbg = document.getElementById('drawBg');
// var navbtns = document.querySelectorAll('.hdr-menu-button');
// var navclose = document.getElementById('mobNavDrawerClose');
// var lastFocusedButton = null;

// function openMenuDrawer(event) {
//   lastFocusedButton = event.currentTarget;

//   navdrawermobile.classList.toggle('open');
//   drawbg.classList.toggle('open');

//   updateMobileLogo();
//   updateHeaderStyle();  // <-- NEW

//   if (navdrawermobile.classList.contains('open')) {
//     setTimeout(() => {
//       navclose.focus();
//     }, 300);
//   }

//   event.preventDefault();
// }

// // Close drawer (shared behavior)
// function closeMenuDrawer() {
//   navdrawermobile.classList.remove('open');
//   drawbg.classList.remove('open');

//   updateMobileLogo();
//   updateHeaderStyle();  // <-- NEW

//   lastFocusedButton?.focus();
// }

// // Close when clicking the close button
// if (navclose) {
//   navclose.addEventListener('click', function() {
//     closeMenuDrawer();
//   });
// }

// // Close when clicking outside (overlay)
// if (drawbg) {
//   drawbg.addEventListener('click', function() {
//     closeMenuDrawer();
//   });
// }





var navdrawermobile = document.getElementById('mobNavDrawer');
var drawbg = document.getElementById('drawBg');
var navbtns = document.querySelectorAll('.hdr-menu-button');
var navclose = document.getElementById('mobNavDrawerClose');
var lastFocusedButton = null;

function openMenuDrawer(event) {
  lastFocusedButton = event.currentTarget;

  navdrawermobile.classList.toggle('open');
  drawbg.classList.toggle('open');

  // ✅ ADD THIS LINE
  document.body.classList.toggle('drawer-open');

  updateMobileLogo();
  updateHeaderStyle();

  if (navdrawermobile.classList.contains('open')) {
    setTimeout(() => {
      navclose.focus();
    }, 300);
  }

  event.preventDefault();
}

// Close drawer (shared behavior)
function closeMenuDrawer() {
  navdrawermobile.classList.remove('open');
  drawbg.classList.remove('open');

  // ✅ ADD THIS LINE
  document.body.classList.remove('drawer-open');

  updateMobileLogo();
  updateHeaderStyle();

  lastFocusedButton?.focus();
}

// Close when clicking the close button
if (navclose) {
  navclose.addEventListener('click', function() {
    closeMenuDrawer();
  });
}

// Close when clicking outside (overlay)
if (drawbg) {
  drawbg.addEventListener('click', function() {
    closeMenuDrawer();
  });
}


// Swap logos based on drawer state
function updateMobileLogo() {
  const defaultLogo = document.querySelector('.header-mobile-logo');
  const drawerLogo = document.querySelector('.header-mobile-logo-drawer');
  const defaultMenu = document.querySelector('.menu-word');
  const drawerClosed = document.querySelector('.close--header-icon');

  if (navdrawermobile.classList.contains('open')) {
    defaultLogo.style.display = 'none';
    drawerLogo.style.display = 'block';
    defaultMenu.style.display = 'none';
    drawerClosed.style.display = 'flex';
    drawerClosed.style.gap = '15px';
    drawerClosed.style.alignItems = 'center';
  } else {
    defaultLogo.style.display = 'block';
    drawerLogo.style.display = 'none';
    defaultMenu.style.display = 'block';
    drawerClosed.style.display = 'none';
  }
}

// 🔥 NEW: Add/remove class on #SiteHeaderInner
function updateHeaderStyle() {
  const headerInner = document.getElementById('SiteHeaderInner');

  if (!headerInner) return;

  if (navdrawermobile.classList.contains('open')) {
    headerInner.classList.add('drawer-open');
  } else {
    headerInner.classList.remove('drawer-open');
  }
}



// Event listeners to each menu button
navbtns.forEach(navbtn => {
  navbtn.addEventListener('click', openMenuDrawer);

  navbtn.addEventListener('keydown', function(event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
      openMenuDrawer(event);
    }
  });
});


// Desktop dropdowns for click option
var panelBg = document.querySelector('.dd-click-drawer-bg');
var lastClickedButton = null;

document.querySelectorAll('.nav-desktop-dd-btn-clickable').forEach(item => {
  item.addEventListener('click', (event) => {
    event.preventDefault();

    const panel = item.nextElementSibling;
    const isSameButton = lastClickedButton === item;
    const gcHeader = document.querySelector('.header-bar-inner');

    // Hide all other panels
    document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(p => {
      if (p !== panel) {
        p.classList.remove("dd-visible");
      }
    });

    if (panel) {
      if (isSameButton) {
        // If clicking the same button, toggle the background visibility
        panel.classList.toggle("dd-visible");
        panelBg.classList.toggle("visible");
        gcHeader.classList.add('hovered');        
      } else {
        // If clicking a different button, ensure background stays visible
        panel.classList.add("dd-visible");
        panelBg.classList.add("visible");
        gcHeader.classList.add('hovered');
      }
    }

    // Update last clicked button
    lastClickedButton = isSameButton ? null : item;
  });
});

// Close all dropdowns when clicking anywhere outside
if (!document.querySelector('.nav-desktop-dd-btn-hover')) {
  document.addEventListener('click', (event) => {
    // Check if the clicked target is not inside a dropdown or clickable button
    if (
      !event.target.closest('.header-nav-desktop-dd-panel') &&
      !event.target.closest('.nav-desktop-dd-btn-clickable') &&
      !event.target.closest('.hdr-search-btn')
    ) {
      // Hide all dropdowns
      document.querySelectorAll('.header-nav-desktop-dd-panel').forEach(panel => {
        panel.classList.remove("dd-visible");
        panelBg.classList.remove("visible");
        document.querySelector('.header-bar-inner').classList.remove('hovered');
      });
    }
  });
}


document.addEventListener('DOMContentLoaded', function () {
  const header = document.getElementById('SiteHeader');
  const spanCartPage = document.getElementById('cart-page-title-cart-count');
  
  if (!header) return;

  // Function to show/hide cart bubble
  function updateCartBubble() {
    const bubble = document.getElementById('cart-icon-bubble');
    if (!bubble) return;

    const count = parseInt(bubble.textContent.replace(/\D/g, ''), 10);
    const parent = bubble.parentElement; // wrapper div

    if (count > 0) {
      parent.style.display = 'flex';
    } else {
      parent.style.display = 'none';
    }
    if (spanCartPage) {
      spanCartPage.textContent = count;         // set inner text
      spanCartPage.parentElement.style.display = count > 0 ? 'inline' : 'none'; // show/hide the wrapper div with parentheses
    }
    
    console.log('Cart count:', count, 'Parent display:', parent.style.display);
  }

  // Initial check on page load
  updateCartBubble();

  // Observe changes inside header
  const observer = new MutationObserver(() => {
    updateCartBubble();
  });

  observer.observe(header, {
    childList: true,
    subtree: true
  });
});

